import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../../shared/services/auth/auth.service';
import {AuthUser} from '../../shared/services/auth/store/auth.models';
import {DashboardMapComponent} from '../../shared/components/dashboard-map/dashboard-map.component';
import {
  SidebarAnnouncementCanvasComponent
} from '../../pages/announcement/user/sidebar-announcement/sidebar-announcement.component';
import {AppMenuService} from '../../shared/services/menu/menu.service';
import {SidebarMenu} from '../sidebar/interface/sidebar-item';
import {ActivatedRoute, Router} from '@angular/router';
import {IcdCodesPopupComponent} from '../../shared/components/icd-code/icd-codes-popup/icd-codes-popup.component';
import {MedicalAdviceComponent} from '../../shared/components/medical-advice/medical-advice.component';
import {CallReceivingPopupComponent} from '../../shared/components/call-receiving-popup/call-receiving-popup.component';
import {CallService} from '../../shared/services/call/call.service';
import {CurrencyComponent} from '../../shared/components/currency/currency.component';
import {VehicleLocationMapComponent} from '../../shared/components/vehicle-location-map/vehicle-location-map.component';
import {AnnouncementService} from '../../pages/announcement/user/services/announcement.service';
import {FileApiService} from '../../shared/services/file-api/file-api.service';
import {SafeUrl} from '@angular/platform-browser';
import {SearchService} from '../../shared/components/search/services/search.service';
import {ShortcutService} from '../../shared/components/shortcut/service/shortcut.service';
import {
  PasswordChangePopupComponent
} from "../../shared/components/password-change-popup/password-change-popup.component";

declare let $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @ViewChild('icdCodePopup')
  icdPopup: IcdCodesPopupComponent;

  @ViewChild('dashboardMedicalAdviceDialog')
  medicalAdviceDialog: MedicalAdviceComponent;

  @ViewChild('callReceivingPopup')
  callReceivingPopup: CallReceivingPopupComponent;

  @ViewChild('vehicleLocationMap')
  vehicleLocationMap: VehicleLocationMapComponent;

  @ViewChild('dashboardMap')
  dashboardMap: DashboardMapComponent;

  @ViewChild('passwordChangePopup')
  passwordChangePopup: PasswordChangePopupComponent;

  functions: { [key: string]: Function } = {
    icdPopup: () => this.icdPopup.initilize(),
    medicalAdviceDialog: () => this.medicalAdviceDialog.openDialog(),
    currencyDialog: () => this.currencyDialog.openDialog(),
    vehicleLocationDialog: () => this.vehicleLocationMap.open(),
    dashboardMapDialog: () => this.dashboardMap.open(),
  }

  @ViewChild('coreMessagesUserCanvas')
  coreAnnouncementUserCanvas: SidebarAnnouncementCanvasComponent;

  @ViewChild('currencyDialog') currencyDialog: CurrencyComponent;
  hasUnreadNotifications = false; // Set this dynamically based on your logic

  user: AuthUser;
  headerMenu: SidebarMenu[] = [];
  openCall: any;
  station: string;
  minimizeCallCard: boolean = true;
  bobbleButton: boolean = true;
  token: string = '';
  photo: SafeUrl | null;


  isFullscreen = false;
  constructor(
    private readonly authService: AuthService,
    private readonly menuService: AppMenuService,
    public router: Router,
    private readonly callService: CallService,
    private readonly route: ActivatedRoute,
    private readonly announcementService: AnnouncementService,
    private readonly fileService: FileApiService,
    private readonly searchService: SearchService,
    private readonly shortcutService: ShortcutService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.menuService.fetchHeaderMenu('header');
    this.user = this.authService.getUserData();
    this.token = this.authService.getToken() ?? '';

    this.route.queryParams.subscribe((params) => {
      if (params['callType'] && params['ucid']) {
        this.callService.triggerCall(params);
        this.minimizeCallCard = false;
      }
      if (params['openSidebar'] === 'true') {
        this.minimizeCallCard = true;
      } else {
        this.callService.getOpenCallCard();
      }
    });

    this.callService.callHeaderFunctionWithData$.subscribe((data) => {
      this.minimizeCallCard = false;

      const index = this.callReceivingPopup.calls.findIndex(
        (val) => val.callId === data.callId && val.phone === data.phone
      );

      this.callReceivingPopup.bringToFront(index, data);
    });

  }

  ngOnInit() {
    this.authService.getAuthActions();

    this.authService.getAuthUser().subscribe({
      next: (res) => {
        const lastUpdate = new Date(res.passwordLastUpdate);
        const now = new Date();

        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(now.getMonth() - 3);

        if (lastUpdate < threeMonthsAgo) {
          this.passwordChangePopup.initilize(lastUpdate==null?'first':'last');
        }

        if (res?.staff?.photo?.fileUrl && this.token) {
          (async () => {
            try {
              const safeUrl = await this.fileService.getFileSafeUrl(
                res.staff.photo.fileUrl,
                this.token
              );
              this.photo = safeUrl;
              this.cdr.detectChanges?.();
            } catch (error) {
              console.error(error);
            }
          })();
        }
      },
    });

    this.menuService.getHeaderMenu().subscribe((response) => {
      this.headerMenu = response;
    });
    $.getScript('assets/theme/w3crm/js/deznav-init.js');

    this.station = localStorage.getItem('station') || '';

    this.callService.calls$.subscribe((res) => {
      this.openCall = res;
    });

    const signedUserId = Number(this.authService.getUserId());
    // kullanıcıya atanmış duyurulardan okunmayan var ise icon üstü red bubble gözükmesi için status true olacak.
    this.announcementService
      .getByFilters({user: signedUserId})
      .subscribe((data: any) => {
        const visibleLoginAnnouncements: any[] =[];
        data.items?.map((i: any) => {
            const readStatus = i?.announcementReadStatuses?.find(
              (status: any) => status.user?.id === signedUserId
            );
            const isSignedUserRead = !!readStatus;
            if (!isSignedUserRead) {
              this.hasUnreadNotifications = true;
            }
            if (i?.reminderType?.id==1107 && !isSignedUserRead){
              visibleLoginAnnouncements.push(i);
            }
        });

        const allReadyLoginRead = data.items.filter((item:any)=>item?.reminderType?.id==1106);
        if (allReadyLoginRead){
          allReadyLoginRead.forEach((item:any)=>{
            visibleLoginAnnouncements.push(item);
          });
        }

        this.prepareQueueFromApi(visibleLoginAnnouncements);
      });
  }


  getShownAnnouncements(): number[] {
    const data = localStorage.getItem('loginAnnouncement');
    return data ? JSON.parse(data) : [];
  }

  addShownAnnouncement(id: number) {
    const shown = this.getShownAnnouncements();

    if (!shown.includes(id)) {
      shown.push(id);
      localStorage.setItem('loginAnnouncement', JSON.stringify(shown));
    }
  }

  prepareQueueFromApi(list: any[]) {
    const shownIds = this.getShownAnnouncements();
    const newAnnouncements = list.filter(a => !shownIds.includes(a.id));

    if (newAnnouncements.length) {
      this.coreAnnouncementUserCanvas.openAnnouncementArray(newAnnouncements);
      newAnnouncements.forEach(a=>{
        this.addShownAnnouncement(a.id);
      })
    }
  }

  openMessagesSidebar() {
    this.coreAnnouncementUserCanvas.openPopup();
  }

  openSearch() {
    this.searchService.triggerSearch();
  }

  async logout() {
    await this.authService.logout(); // Servis zaten temizliği ve isteği yapıyor
  }

  minimizeCallCardSet(status: boolean) {
    this.minimizeCallCard = status;
    this.callReceivingPopup.setResultCodes();
  }

  handleItemClick(item: any): any {
    if (item.items.length == 0) {
      // Öğenin altında eleman yoksa ve url özelliği tanımlıysa, yönlendirme yap

      switch (item.urlType) {
        case 'ROUTE':
          if (item.targetBlank) {
            window.open(item.url);
          } else {
            this.router.navigate([item.url]);
          }
          break;
        case 'EXTERNAL':
          globalThis.location.href = item.url;
          break;
        case 'STATIC':
          globalThis.location.href = item.url;
          break;
        case 'FUNCTION': {
          const func = this.functions[item.url];
          if (typeof func === 'function') {
            func();
          }
          break;
        }
      }
    }

    // Eğer öğenin altında başka öğeler varsa ve açıksa, kapat
    if (item.items.length > 0 && item.expanded) {
      item.expanded = false;
      item.active = '';
      item.ariaExpanded = false;
      item.mmShow = '';
    } else if (item.items.length > 0) {
      // Eğer öğenin altında başka öğeler varsa ve kapalıysa, aç
      item.expanded = true;
      item.active = 'mm active';
      item.ariaExpanded = true;
      item.mmShow = 'mm-show';
    }
  }

  saveStation() {
    this.callService.saveStation(this.station);
  }

  goToDashboard() {
    this.router.navigate(['/dashboard/operations']);
  }

  toogleShortcut() {
    this.shortcutService.triggerShortcut();
  }

  toggleDropdown() {
    // açık/kapalı kontrolü yok boş kalacak
  }

  toggleFullscreen(): void {
  const elem = document.documentElement;

  if (this.isFullscreen) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
    this.isFullscreen = false;
  } else {

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if ((elem as any).webkitRequestFullscreen) {
      (elem as any).webkitRequestFullscreen();
    } else if ((elem as any).msRequestFullscreen) {
      (elem as any).msRequestFullscreen();
    }
    this.isFullscreen = true;
  }
}
  protected readonly window = globalThis;
}
